import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import _orderBy from 'lodash/orderBy';
import { PureComponent } from 'react';
import CustomCardsItem from '../../../containers/sidebar/cards/customCardsItem';
import '../../../styles/cards.less';
export class CustomCards extends PureComponent {
    getAllIntegrations() {
        const { integrations, async_integrations } = this.props;
        const mergedIntegrations = [];
        if (async_integrations) {
            for (const async of async_integrations) {
                let foundIntegration = undefined;
                if (integrations) {
                    foundIntegration = integrations.find((integration) => async.hook_id === integration.id);
                }
                if (foundIntegration) {
                    const matchedIntegration = Object.assign({}, foundIntegration);
                    matchedIntegration['card_type'] = async.card_type;
                    matchedIntegration['title'] = async.title;
                    mergedIntegrations.push(matchedIntegration);
                }
                else {
                    mergedIntegrations.push(async);
                }
            }
        }
        return mergedIntegrations;
    }
    getOrderOfIntegrations(mergedIntegrations) {
        return _orderBy(mergedIntegrations, ['description', 'title']);
    }
    render() {
        const { isMinimized } = this.props;
        const sortedIntegrations = this.getOrderOfIntegrations(this.getAllIntegrations());
        return (_jsx(_Fragment, { children: sortedIntegrations.map((card, index) => {
                const id = card['hook_id'] || card['id'];
                return (_jsx(CustomCardsItem, { card: card, isMinimized: isMinimized }, id || index));
            }) }));
    }
}
